module.exports = __webpack_public_path__ + "static/img/cert1.06b58ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cert1.png
// module id = Q7Qk
// module chunks = 1